import { makeStyles } from "@material-ui/core";

export const approveActivityStyle = makeStyles(theme => ({
    btn:{
        whiteSpace: 'normal',
        width: '11em'
    }
}))